require('./subnav.scss');
var setStickyTo = require('src/interlock/no-ui/sticky/sticky');

var SELECTOR_NAV_BAR_ACTIVE_LINK = '.nav-link.active';
var $navBar = $('#subnav .navbar-nav');

/**
 * Offset 150 is far enough offset to cover global nav height + header height.
 */
$(document).ready(function() {
    $('body').scrollspy({offset: 150, target: '#subnav'});

    setStickyTo($('[data-toggle="sticky-on-scroll"]'));
});

/**
 * This handles for href with links for SEO purposes.
 * data-target is the id of the module where HREF is the link
 * i.e.
 * <a class="nav-link active" href="/groundwork/chevrolet/malibu/2017/safety/"
 *  data-target="#edm-entry-safety">
 *      safety
 * </a>
 */
$('#subnav .nav-link').on('click', function (e) {
    var target = $(this).data('target');
    if (target && !$(this).data('external-link')) {
        e.preventDefault();
        $(window).scrollTop($(target).offset().top);
    }
});

$(window).on('activate.bs.scrollspy', function(){
    var $activeCategory = $navBar.find(SELECTOR_NAV_BAR_ACTIVE_LINK);
    if($activeCategory.length){
        moveActiveCategoryToCenter($navBar, $navBar.find(SELECTOR_NAV_BAR_ACTIVE_LINK));
    }
});

function moveActiveCategoryToCenter($scrolledArea, $activeCategory){
    var scrollTo = $scrolledArea.scrollLeft()
        + $activeCategory.position().left
        - parseInt($scrolledArea.css('padding-left'))
        - $scrolledArea.width() / 2
        + $activeCategory.width() / 2;

    $scrolledArea.animate({
        scrollLeft: scrollTo,
        duration: 600
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/subnav/subnav.js
// module id = 27
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14